module.exports = __webpack_public_path__ + "img/example3-2.54297685.png";